const axios = require('axios')
const uuid = require('uuid/v4')

class ChatterService {
  constructor({ url, websocket, storage, channelId, token }) {
    this.channelId = channelId
    this.token = token
    this.api = {
      http: url,
      websocket: websocket,
      storage: storage,
    }

    this.axios = axios.create({
      headers: { Authorization: `Bearer ${this.token}` }
    })
  }

  async getHistory(user) {
    try {
      const res = await this.axios.get(`${this.api.http}/history?user=${user}`)

      return res.data.history;
    } catch (error) {
      console.log(error)
    }
  }

  async getNewCredentials() {
    return {
      user: uuid(),
    }
  }

  async uploadFile(file) {
    let formData = new FormData()
    formData.append('file', file)
    let res = await this.axios.post(
      `${this.api.storage}/files`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    let { url } = res.data

    return { url }
  }
}

module.exports = ChatterService